export default __webpack_public_path__ + "static/media/girl&timer.fc6e5efa.svg";